import { render, staticRenderFns } from "./AddManufactory.vue?vue&type=template&id=7ae9f9e9"
import script from "./AddManufactory.vue?vue&type=script&lang=ts"
export * from "./AddManufactory.vue?vue&type=script&lang=ts"
import style0 from "./AddManufactory.vue?vue&type=style&index=0&id=7ae9f9e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports